import compose from "recompose/compose";
import Addons from "./Addons";
import GoogleSheet from "./contents/Google/Sheet/Main";
import GoogleSheetConfig from "./contents/Google/Sheet/Config";
import GoogleSpreadsheet from "./contents/Google/Sheet/Spreadsheet";

export default compose(Addons, GoogleSheet, GoogleSheetConfig, GoogleSpreadsheet);